import React from "react";
import Flagship from "../../core/flagship";
import Field from "./Field";
import { shouldShowField, clean } from "../../utils/helpers";

class IoProductFields extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.onChange = this.onChange.bind(this);
  }

  getInitialState() {
    return {
      fields: [],
      fieldData: {},
      loading: true,
      requiredMissing: false
    };
  }

  onChange(e, data, fieldId) {
    this.props.onChange(e, data, fieldId);
  }

  componentWillReceiveProps(nextProps) {
    let self = this;

    Flagship.get(
      "fields/io-" + nextProps.service,
      {
        active: true
      },
      function(response) {
        if (response.data.success === true) {
          self.setState(
            {
              fields: response.data.results
            },
            function() {
              self.setState({
                loading: false
              });
            }
          );
        } else {
          Flagship.error(
            "Error getting IO product form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Error getting IO product form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  render() {
    let self = this;

    return (
      <div>
        {this.state.fields.map(function(item) {
          let fieldId = item.id;
          item = clean(item);

          return shouldShowField(item, self.state.fieldData) ? (
            <Field
              contentType="ioProduct"
              model={"IoProduct." + item.id}
              value={item.default}
              index={fieldId}
              filterInput={item.validation !== "" ? item.validation : null}
              key={"field-" + fieldId}
              onChange={(e, value, fieldId) =>
                self.onChange(e, value, fieldId, item)
              }
              {...item}
            />
          ) : null;
        })}
      </div>
    );
  }
}

export default IoProductFields;



// WEBPACK FOOTER //
// ./src/components/misc/IoProductFields.js